import { makeStyles, Theme } from "@material-ui/core";

interface StyleProps {
  isClickable: boolean;
  backgroundColor: string | undefined;
}

export const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
    whiteSpace: "normal",
    overflowWrap: "break-word",
  },
  inputInterior: {
    cursor: ({isClickable}) => isClickable ? "pointer" : "text",
    height: 40,
    boxSizing: "border-box",
  },
  outlinedWhiteBg: {
    lineHeight: 0,
    "& .MuiOutlinedInput-root": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: 10,

      backgroundColor: ({backgroundColor}) => backgroundColor || theme.palette.common.white,
      "& fieldset": {
        borderColor: theme.palette.secondary.main,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.secondary.dark,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.secondary.dark,
        borderWidth: 1,
      },
    },
    "& .MuiInputBase-input": {
      fontSize: theme.typography.subtitle2.fontSize,
      fontWeight: theme.typography.subtitle2.fontWeight,
      letterSpacing: theme.typography.subtitle2.letterSpacing,
    },
  },
  errorOutline: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.error.main,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.error.dark,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.error.dark,
      },
    },
  },
  additionalPadding: {
    "& .MuiOutlinedInput-root": {
      padding: "8.5px 5px 8.5px 14px", // Apply the conditional padding
    },
  },
  greyBackground: {
    "& .MuiOutlinedInput-root": {
      background: theme.palette.grey[100], // Apply the conditional padding
    },
  },
  helper: {
    fontSize: "0.75rem",
  },
  error: {
    fontSize: "0.75rem",
    color: theme.palette.error.main,
  },
  iconsContainer: {
    display: "flex",
    alignItems: "center",
  },
  clearOption: {
    borderRadius: 50,
    backgroundColor: "#f2f2f2",
    padding: 2,
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));
